




import { closeV2Challenge, loadRecaptchaScript, renderV2, resetV2 } from "@/helper/recaptchaHelper";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class RecaptchaV2Widget extends Vue {
  @Prop({
    type: String,
    default: () =>
      process.env.VUE_APP_RecaptchaEnterprise_CheckboxSiteKey || process.env.VUE_APP_RecaptchaV2_SiteKey || "",
  })
  private siteKey!: string;

  @Prop({
    type: String,
    default: () =>
      process.env.VUE_APP_RecaptchaEnterprise_ScoreSiteKey || process.env.VUE_APP_RecaptchaV3_SiteKey || "",
  })
  private v3SiteKey!: string;

  private widgetId: number | null = null;

  async mounted(): Promise<void> {
    try {
      await loadRecaptchaScript(this.v3SiteKey);
      const container = this.$refs.recaptchaContainer as HTMLElement;
      this.widgetId = renderV2(container, this.siteKey, {
        onVerify: (token: string) => this.$emit("verify", token),
        onExpired: () => this.$emit("expired"),
        onError: () => this.$emit("error"),
        action: "login",
      });
    } catch {
      this.$emit("error");
    }
  }

  public reset(): void {
    if (this.widgetId !== null) {
      resetV2(this.widgetId);
    }
  }

  beforeDestroy(): void {
    // The challenge overlay lives on document.body, outside this component.
    // Reset the widget and force-hide any orphaned overlay so it can't stay
    // stuck on screen when we navigate away after a successful verify (LIFF).
    this.reset();
    closeV2Challenge();
  }
}
